import { Eye } from "lucide-react";
import { useState } from "react";
import preview1 from "../assets/preview1.png";
import preview2 from "../assets/preview2.png";
import preview3 from "../assets/preview3.png";
import preview4 from "../assets/preview4.png";

const PREVIEWS = [
	{
		src: preview1,
		alt: "Screen recording software editor with zoom effects and timeline controls",
		width: 1111,
		height: 953,
	},
	{
		src: preview2,
		alt: "Screen and audio recorder interface with cursor spotlight and click effects",
		width: 1111,
		height: 953,
	},
	{
		src: preview3,
		alt: "Windows and Mac screen recording software export settings with device frames",
		width: 1111,
		height: 953,
	},
	{
		src: preview4,
		alt: "Video recording and editing software background wallpapers and styling options",
		width: 1111,
		height: 951,
	},
];

export function Showcase() {
	const [lightbox, setLightbox] = useState<number | null>(null);

	return (
		<section id="preview" className="py-24 md:py-32">
			<div className="mx-auto max-w-6xl px-6">
				{/* Section header */}
				<div className="text-center mb-16">
					<div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-white/[0.04] border border-white/[0.06] text-xs text-white/40 mb-4">
						<Eye size={12} className="text-brand-400" />
						Preview
					</div>
					<h2 className="text-3xl md:text-5xl font-extrabold tracking-tight">
						See <span className="gradient-text">Clapio</span> in action
					</h2>
					<p className="text-white/40 mt-4 text-base md:text-lg max-w-2xl mx-auto">
						Explore a screen recorder for Mac, Windows, and Linux that combines recording, editing,
						and export tools in one polished workspace.
					</p>
				</div>

				{/* Preview grid — 2×2 with hover zoom */}
				<div className="grid grid-cols-1 md:grid-cols-2 gap-4">
					{PREVIEWS.map((preview, i) => (
						<button
							key={i}
							onClick={() => setLightbox(i)}
							className="group relative rounded-xl overflow-hidden border border-white/[0.06] hover:border-brand-500/30 transition-all duration-300 cursor-zoom-in"
						>
							<img
								src={preview.src}
								alt={preview.alt}
								width={preview.width}
								height={preview.height}
								className="w-full h-auto block group-hover:scale-[1.02] transition-transform duration-500"
								loading="lazy"
								decoding="async"
							/>
							{/* Hover overlay */}
							<div className="absolute inset-0 bg-black/0 group-hover:bg-black/20 transition-colors duration-300 flex items-center justify-center">
								<div className="opacity-0 group-hover:opacity-100 transition-opacity duration-300 bg-black/50 backdrop-blur-sm px-3 py-1.5 rounded-lg text-xs text-white/80">
									Click to expand
								</div>
							</div>
						</button>
					))}
				</div>
			</div>

			{/* Lightbox */}
			{lightbox !== null && (
				<div
					className="fixed inset-0 z-[100] flex items-center justify-center bg-black/80 backdrop-blur-md cursor-zoom-out"
					onClick={() => setLightbox(null)}
				>
					<img
						src={PREVIEWS[lightbox].src}
						alt={PREVIEWS[lightbox].alt}
						width={PREVIEWS[lightbox].width}
						height={PREVIEWS[lightbox].height}
						className="max-w-[90vw] max-h-[90vh] rounded-xl shadow-2xl object-contain"
						decoding="async"
					/>
					{/* Nav dots */}
					<div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex items-center gap-2">
						{PREVIEWS.map((_, i) => (
							<button
								key={i}
								onClick={(e) => {
									e.stopPropagation();
									setLightbox(i);
								}}
								className={`w-2 h-2 rounded-full transition-all ${
									i === lightbox ? "bg-brand-400 w-6" : "bg-white/30 hover:bg-white/50"
								}`}
							/>
						))}
					</div>
				</div>
			)}
		</section>
	);
}
